import { Textbaustein, Variable } from './VorlageModels';

export class Vertrag {
  id: number = 0;
  titel: string = '';
  titelEN: string = '';
  type: number = 0;
  personaldatenGuid: string = '';

  vertragsBeginn: string | null = null;
  vertragsEnde: string | null = null;

  vorlageid: number | null = null;

  textabschnitte: Array<TextAbschnitt> = new Array<TextAbschnitt>();
  inputs: Array<Input> = new Array<Input>();
  vertragdokumente: Array<VertragDokument> = new Array<VertragDokument>();

  vertragspartei1: Vertragspartei = new Vertragspartei();
  vertragspartei2: Vertragspartei = new Vertragspartei();

  adate: Date = new Date();
  mdate: Date = new Date();

  ddate: string | null = null;
  edate: Date | null = null;
  vdate: Date | null = null;

  standort: string = '';
  tarifgebiet: string = '';

  kfWaerendProbezeit: string = ''; // Kündigungsfrist während der Probezeit
  kfWaerendProbezeitEN: string = ''; // Kündigungsfrist während der Probezeit
  kfNachProbezeit: string = ''; // Kündigungsfrist nach der Probezeit
  kfNachProbezeitEN: string = ''; // Kündigungsfrist nach der Probezeit

  zeichnung1: string = '';
  unterschrift1: string = '';
  funktion1: string = '';
  funktion1EN: string = '';

  zeichnung2: string = '';
  unterschrift2: string = '';
  funktion2: string = '';
  funktion2EN: string = '';

  hrbpStandard: string = '';
  auVorlage: string = '';

  docId: string | null = null;
  actionId: string | null = null;

  archivBenutzer: string = '';
}

export class VertragItem {
  id: number = 0;
  titel: string = '';
  type: number = 0;
  personaldatenGuid: string = '';
  adate: Date = new Date();
  vertragspartei1: Vertragspartei = new Vertragspartei();
  vertragspartei2: Vertragspartei = new Vertragspartei();
}

export class Vertragspartei {
  id: number = 0;
  anrede: string = '';
  name: string = '';
  vorname: string = '';
  unternehmen: string = '';
  unternehmenzusatz: string = '';
  strasse: string = '';
  plz: string = '';
  ort: string = '';
  land: string = '';
}

export class Input {
  id: number;
  vertragid: number;
  variableid: number;
  variable: Variable;
  value: string;
  valueEN: string;

  constructor(variableid: number, variable: Variable, vertragid: number, value: string, valueEN: string = '') {
    this.id = 0;
    this.vertragid = vertragid;
    this.variableid = variableid;
    this.variable = variable;
    this.value = value;
    this.valueEN = valueEN;
  }
}

export class TextAbschnitt {
  id: number;
  position: number;
  selected: boolean;
  // optional: boolean;
  vertragid: number;
  textbaustein: Textbaustein;
  textbausteinid: number;
  ownerid: number | null;
  abschnitte: Array<TextAbschnitt>;

  constructor(
    id: number,
    vertragid: number,
    position: number,
    selected: boolean,
    // optional: boolean,
    textbausteinid: number,
    ownerid: number | null,
    abschnitte: Array<TextAbschnitt>
  ) {
    this.id = id;
    this.position = position;
    this.selected = selected;
    // this.optional = optional;
    this.vertragid = vertragid;
    this.textbaustein = new Textbaustein();
    this.textbausteinid = textbausteinid;
    this.ownerid = ownerid;
    this.abschnitte = abschnitte;
  }
}

export class VertragDokument {
  id: number = 0;
  vertragid: number = 0;
  fileName: string = '';
  data: string = '';
  adate: Date = new Date();
  mdate: Date = new Date();
  archivBenutzer: string = '';
}

export class GenerateWordDocumentRequest {
  titel: string;
  vertragspartner2Name: string;
  text: string;
  dokumentId: number | null;
  qrCodeData: string | null;
  fileName: string;

  constructor(
    titel: string,
    vertragsparnter2Name: string,
    text: string,
    dokumentId: number | null = null,
    qrCodeData: string | null = null,
    fileName: string = 'dokument.docx'
  ) {
    this.titel = titel;
    this.vertragspartner2Name = vertragsparnter2Name;
    this.text = text;
    this.dokumentId = dokumentId;
    this.qrCodeData = qrCodeData;
    this.fileName = fileName;
  }
}

//#region Analysen

export class FetchVertragAnalysenRequest {
  startDate: string | null;
  endDate: string | null;

  constructor(startDate: string | null = null, endDate: string | null = null) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export class VertragAnalyse {
  totalCount: number = 0;
  neuvertragCount: number = 0;
  nachtragCount: number = 0;
  startDate: Date | null = null;
  endDate: Date | null = null;
  neuvertraegeByPartner: VertragCountByPartner[] = [];
  nachtraegeByPartner: VertragCountByPartner[] = [];
}

export class VertragCountByPartner {
  partnerName: string = '';
  count: number = 0;
  vorlaufzeit: number = 0; // Vorlaufzeit in Tagen
}
//#endregion
